import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLogoutMutation } from '../redux/api/authApi';
import { AppDispatch } from '../redux/store';
import toast from 'react-hot-toast';
import { performGlobalLogout } from '../utils/logoutUtils';

export const useLogout = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [logoutMutation, { isLoading }] = useLogoutMutation();

  const handleLogout = useCallback(async () => {
    try {
      // Call backend logout endpoint
      await logoutMutation().unwrap();
      
      await performGlobalLogout(dispatch, {
        toastMessage: 'Signed out successfully',
        toastType: 'success',
      });

      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Failed to sign out. Please try again.');
    }
  }, [dispatch, navigate, logoutMutation]);

  return {
    handleLogout,
    isLoading,
  };
};
